<template>
  <div class="business-content-main">
    <div class="bread-nav">
      <breadcrumb :canBackHistory="true"></breadcrumb>
    </div>
    <div class="detail-container">
      <div class="detail-top">
        <div class="detail-top-left">
          <div class="image-ctn goods-cover">
            <el-image style="width: 350px; height: 350px" :src="mainImg" :onerror="defaultImg">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
          <div class="toggle-img-ctn" v-if="reviewImgs.length>0">
            <div
              class="imgCard"
              :key="index"
              v-for="(item,index) in reviewImgs"
              @mouseover="imgOverHandler(index)"
            >
              <el-card shadow="hover">
                <el-image
                  class="elImg"
                  :src="item"
                  :onerror="defaultImg"
                  :preview-src-list="reviewImgs"
                  fit='contain'
                ></el-image>
              </el-card>
            </div>
          </div>
        </div>
        <div class="detail-top-right">
          <div class="top">
            <div class="Name">{{qpData.Name}}</div>
          </div>
          <div class="top">
            <div class="title">编码</div>
            <div class="content">{{qpData.Code}}</div>
          </div>
          <div class="top">
            <div class="title">品牌</div>
            <div class="content">{{qpData.Brands}}</div>
          </div>
          <div class="goods-dir">
            <div class="goods-introduction">
              <div class="goods-param">
                <div class="title">互换码</div>
                <div class="content">{{qpData.ChangeCode}}</div>
                <div class="title">英文名称</div>
                <div class="content" v-if="qpData.Name">
                  <template v-for="(item,index) in qpData.Name.split(' ')">
                    <span :key="index" v-if="index!=0">{{item}}&#8194;</span>
                  </template>
                </div>
              </div>
            </div>
            <div class="goods-introduction">
              <div class="goods-param">
                <div class="title">车型描述</div>
                <div class="content">{{qpData.VehicleDesc}}</div>
                <div class="title">产地</div>
                <div class="content"></div>
              </div>
            </div>
            <div class="goods-introduction">
              <div class="goods-param">
                <div class="title">单位</div>
                <div class="content">{{qpData.Unit}}</div>
                <div class="title">重量</div>
                <div class="content">{{qpData.Weight}}</div>
              </div>
            </div>
            <div class="goods-introduction">
              <div class="goods-param">
                <div class="title">配件尺寸</div>
                <div class="content">{{qpData.Size}}</div>
                <div class="title">包装尺寸</div>
                <div class="content">{{qpData.PackageSize}}</div>
              </div>
            </div>
            <div class="goods-introduction">
              <div class="goods-param">
                <div class="title">使用里程建议</div>
                <div class="content">{{qpData.KilometerAdvice}}</div>
                <div class="title">使用时长建议</div>
                <div class="content">{{qpData.DurationAdvice}}</div>
              </div>
            </div>
          </div>
          <div>
            <el-button class="btn-primary" size="medium" @click.stop="askPJ()">向客服询价</el-button>
          </div>
        </div>
      </div>
      <div class="detail-body-title">
        <div class="title">适配车型</div>
      </div>
      <div class="detail-body">
        <div class="tableHead">
          <div class="brand">品牌</div>
          <div class="cn">车系</div>
          <div class="emission">排量</div>
          <div class="year">年款</div>
          <div class="engine">发动机型号</div>
          <div class="transmission">变速箱</div>
          <div class="drive">驱动类型</div>
          <div class="carbody">销售型</div>
        </div>
        <div class="tableBody" :key="index" v-for="(item,index) in qpData.BrandGrouping">
          <div class="brandName">
            <div>{{item.BrandName}}</div>
          </div>
          <div class="series" :key="index2" v-for="(item2,index2) in item.AutoSerieGrouping">
            <div class="autoSerieName">
              <span>{{item2.AutoSerieName}}</span>
            </div>
            <div class="param">
              <div class="detail" :key="index3" v-for="(item3,index3) in item2.AutoSeries">
                <div class="cn">{{item3.Cn}}</div>
                <div class="emission">{{item3.Emission}}</div>
                <div class="year">{{item3.ModelYear}}</div>
                <div class="engine">{{item3.EngineType}}</div>
                <div class="transmission">{{item3.TransmissionType}}</div>
                <div class="drive">{{item3.DriveStyle}}</div>
                <div class="carbody">{{item3.CarBody}}</div>
              </div>
            </div>
          </div>
        </div>
        <div v-if="qpData.AutoSerieList&&qpData.AutoSerieList.length==0" class="empty">
          <div>
            <span>暂无数据</span>
          </div>
        </div>
      </div>
    </div>
    <el-backtop target=".business-content" :right="100" :bottom="100" :visibility-height="300"></el-backtop>
  </div>
</template>
<script>
import breadcrumb from "@/components/common/breadcrumb";
import mixin from "@/mixins/mixin";
export default {
  mixins: [mixin],
  name: "qpdetail",
  components: {
    breadcrumb
  },
  data() {
    return {
      browseId: "",
      coverIndex: 0,
      defaultImg: 'this.src="' + this.$util.DEFAULT_IMAGE_square + '"',
      downloadUrl: this.$util.QN_URL_BASE,
      goodsId: "",
      qpData: {},
      permission: {},
      reviewImgs: [],
      mainImg: "",
      mainImgsCopy: ""
    };
  },
  created() {
    this.browseId = this.$route.query.id;
    this.goodsId = this.$route.query.id;
    this.permission = this.$util.getPermission("AutoPartsLib");
    this.getTableData();
  },
  mounted() {},
  methods: {
    back() {
      this.$router.push("/search/qpSearch");
    },
    imgOverHandler(index) {
      let img = this.reviewImgs[index];
      this.mainImg = img;
    },
    askPJ() {
      if (this.$store.state.connectState != 2) {
        this.$util.warningMsg("请先连接到客服再进行询问");
        return;
      }
      let qp = {
        Cn: this.qpData.Name,
        Code: this.qpData.Code,
        Id: this.qpData.Id,
        PublicUrl: this.qpData.PublicUrl
        // UpdateTime: "2020-07-02 14:39:39"
      };
      this.$store.commit("updateAskPJMsg", qp);
      this.$util.successMsg("已向客服发送该商品");
    },
    swithImg(val) {
      this.mainImg = val;
    },
    // 获取数据
    getTableData() {
      this.$util
        .axiosGet({
          url: "/api/AutoParts/GetAutoPartsDetail",
          data: {
            apId: this.goodsId
          }
        })
        .then(res => {
          if (!res.data) {
            this.qpData = [];
            return;
          }
          this.qpData = res.data;
          let imgs = this.qpData.Images;
          this.mainImg = this.qpData.PublicUrl
            ? this.downloadUrl + this.qpData.PublicUrl
            : "";
          this.mainImgsCopy = this.qpData.PublicUrl
            ? this.downloadUrl + this.qpData.PublicUrl
            : "";
          this.reviewImgs = [];
          for (let index = 0; index < imgs.length; index++) {
            const element = imgs[index];
            let url = element ? this.downloadUrl + element : "";
            this.reviewImgs.push(url);
          }
        })
        .catch(() => {});
    }
  }
};
</script>
<style lang="less">
.detail-top-left {
  .image-ctn {
    img {
      object-fit: contain;
    }
  }
}
</style>
<style lang="less" scoped>
.bread-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.goods-msg {
  display: flex;
  align-items: center;
  height: 39px;
}
.tb-metatit {
  color: #999;
  font-size: 12px;
  text-align: left;
  float: left;
  width: 100px;
  margin: 0 0 0 8px;
}
.tm-yen {
  color: #ff0036;
  font-size: 18px;
  font-family: Arial;
}
.goods-price {
  display: flex;
  align-items: center;
  padding-left: 20px;
  background-color: @border3Color;
  padding: 20px 0;
  margin-right: 20px;
  font-size: 30px;
  color: red;
  font-weight: bolder;
  font-family: Arial;
}
.goods-name {
  padding: 20px 10px 20px 0;
  line-height: 1;
  font-size: 16px;
  font-weight: 700;
}
.goods-cover {
  border: 1px solid @border3Color;
  width: 350px;
  height: 350px;
  text-align: center;
  img {
    max-width: 350px;
    max-height: 350px;
  }
}
.detail-container {
  position: relative;
  width: 1000px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
}
.detail-top {
  display: flex;
  width: 100%;
  margin-bottom: 20px;
}
.detail-top-left {
  width: 350px;
  margin-right: 20px;
  .toggle-img-ctn {
    background-color: #fafafa;
    height: 120px;
    overflow-x: auto;
    margin-top: 15px;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    .imgCard {
      width: 100px;
      height: 100px;
      margin-right: 5px;
    }
    // .elImg {
    //   width: 100px;
    //   height: 100px;
    // }
  }
}
.detail-top-right {
  width: 650px;
  .top {
    width: 100%;
    display: flex;
    margin-bottom: 20px;
    align-content: center;
    align-items: center;
    .Name {
      font-size: 36px;
      font-weight: bold;
      margin-bottom: 10px;
    }
    .title {
      font-size: 18px;
      line-height: 18px;
    }
    .content {
      font-size: 18px;
      line-height: 18px;
      margin-left: 25px;
    }
  }
}
.goods-dir {
  width: 100%;
  margin-bottom: 20px;
  border-top: 1px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
}
.goods-introduction {
  height: auto;
}
.goods-param {
  display: flex;
  width: 100%;
  height: auto;

  .title {
    background-color: #f2f6fc;
    width: 250px;
    height: 40px;
    border-bottom: 1px solid #dcdfe6;
    border-right: 1px solid #dcdfe6;
  }
  .content {
    height: 40px;
    border-bottom: 1px solid #dcdfe6;
    border-right: 1px solid #dcdfe6;
  }
  div {
    width: 100%;
    line-height: 40px;
    text-align: center;
  }
}
.detail-body-title {
  width: 100%;
  border: 1px solid #dcdfe6;
  height: 40px;
  background-color: white;
  display: flex;
  justify-content: right;
  align-content: center;
  border-bottom: 1px solid #8c98cc;
  .title {
    color: white;
    padding: 10px;
    text-align: center;
    align-content: center;
    width: auto;
    background-color: #8c98cc;
  }
}
.detail-body {
  display: flex;
  flex-direction: column;
  text-align: center;
  border-top: 1px solid #dcdfe6;
  border-left: 1px solid #dcdfe6;
  .brand {
    width: 120px;
    height: 25px;
    line-height: 25px;
  }
  .cn {
    width: 150px;
    height: 25px;
    line-height: 25px;
  }
  .emission {
    width: 100px;
    height: 25px;
    line-height: 25px;
  }
  .year {
    width: 120px;
    height: 25px;
    line-height: 25px;
  }
  .engine {
    width: 150px;
    height: 25px;
    line-height: 25px;
  }
  .transmission {
    width: 120px;
    height: 25px;
    line-height: 25px;
  }
  .carbody {
    width: 120px;
    height: 25px;
    line-height: 25px;
  }
  .drive {
    width: 120px;
    height: 25px;
    line-height: 25px;
  }
  .tableHead {
    display: inline-flex;
    background-color: #f2f6fc;
    border-bottom: 1px solid #dcdfe6;
    div {
      height: 40px;
      line-height: 40px;
      border-right: 1px solid #dcdfe6;
    }
  }
  .tableBody {
    .brandName {
      width: 100%;
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #dcdfe6;
      border-right: 1px solid #dcdfe6;
      background: rgb(236, 245, 255);
      div {
        width: 10%;
      }
    }
    .autoSerieName {
      width: 120px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .param {
      display: flex;
      flex-direction: column;
      .detail {
        display: flex;
        border-bottom: 1px solid #dcdfe6;
        border-right: none;
        .cn {
          width: 150px;
        }
        .emission {
          width: 100px;
        }
        .year {
          width: 120px;
        }
        .engine {
          width: 150px;
        }
        .transmission {
          width: 120px;
        }
        .carbody {
          width: 120px;
        }
        .drive {
          width: 120px;
        }
      }
    }
    .series {
      display: flex;
      flex-direction: row;
      border-bottom: 1px solid #dcdfe6;
      div {
        border-right: 1px solid #dcdfe6;
      }
      .cn {
        background: rgb(233, 233, 235);
      }
      .emission {
        background: rgb(244, 244, 245);
      }
      .year {
        background: rgb(233, 233, 235);
      }
      .engine {
        background: rgb(244, 244, 245);
      }
      .transmission {
        background: rgb(233, 233, 235);
      }
      .carbody {
        background: rgb(244, 244, 245);
      }
      .drive {
        background: rgb(233, 233, 235);
      }
    }
  }
  .empty {
    width: 100%;
    padding-top: 10px;
    padding-bottom: 10px;
    text-align: center;
    border-bottom: 1px solid #dcdfe6;
    border-right: 1px solid #dcdfe6;
  }
}
</style>
